<!-- KPI Cards -->
<div class="row g-3 mb-4">
    <!-- Total de Empresas -->
    <div class="col-lg-3 col-md-6">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="kpi-icon-simple">
                        <i class="ti ti-building-skyscraper ti-xl"></i>
                    </div>
                    <button class="btn btn-sm btn-link text-decoration-none p-0" (click)="viewAllCompanies()">
                        <i class="ti ti-arrow-right"></i>
                    </button>
                </div>
                <h2 class="mb-1">{{ totalCompanies | number }}</h2>
                <p class="text-muted mb-0 small">Empresas</p>
            </div>
        </div>
    </div>

    <!-- Dívidas Estimadas -->
    <div class="col-lg-3 col-md-6">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="kpi-icon-simple">
                        <i class="ti ti-receipt-2 ti-xl"></i>
                    </div>
                </div>
                <h2 class="mb-1">{{ totalDebt | currency:'BRL':'symbol':'1.0-0' }}</h2>
                <p class="text-muted mb-0 small">Dívidas Estimadas</p>
            </div>
        </div>
    </div>

    <!-- Usuários Ativos -->
    <div class="col-lg-3 col-md-6">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="kpi-icon-simple">
                        <i class="ti ti-users ti-xl"></i>
                    </div>
                </div>
                <h2 class="mb-1">{{ totalUsers }}</h2>
                <p class="text-muted mb-0 small">Usuários no Sistema</p>
            </div>
        </div>
    </div>

    <!-- Taxa SELIC Atual -->
    <div class="col-lg-3 col-md-6">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                    <div class="kpi-icon-simple">
                        <i class="ti ti-chart-line ti-xl"></i>
                    </div>
                    <button class="btn btn-sm btn-link text-decoration-none p-0" (click)="viewSelic()">
                        <i class="ti ti-arrow-right"></i>
                    </button>
                </div>
                <h2 class="mb-1">{{ currentSelicRate | number:'1.2-2' }}%</h2>
                <p class="text-muted mb-0 small">Taxa SELIC ({{ selicReferenceDate }})</p>
            </div>
        </div>
    </div>
</div>

<!-- Empresas Recentes -->
<div class="row g-3">
    <div class="col-12">
        <div class="card border-0 shadow-sm">
            <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                <div>
                    <h5 class="mb-0">Empresas Recentes</h5>
                    <small class="text-muted">Últimas empresas cadastradas no sistema</small>
                </div>
                <button class="btn btn-sm btn-dark" (click)="viewAllCompanies()">
                    Ver Todas <i class="ti ti-arrow-right"></i>
                </button>
            </div>
            <div class="card-body p-0">
                @if (loading) {
                    <div class="text-center p-5">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                } @else if (latestCompaniesWithDebt.length === 0) {
                    <div class="text-center p-5 text-muted">
                        <i class="ti ti-inbox ti-lg mb-2"></i>
                        <p>Nenhuma empresa cadastrada ainda</p>
                    </div>

                } @else {
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead>
                            <tr>
                                <th class="ps-4">Empresa</th>
                                <th>Cidade/UF</th>
                                <th>Contato</th>
                                <th class="text-end">Parcelas Restantes</th>
                                <th class="text-end pe-4">Dívidas Estimadas</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (company of latestCompaniesWithDebt; track company.documentNumber) {
                                    <tr class="cursor-pointer" (click)="viewCompanyDetails(company.documentNumber)">
                                        <td class="ps-4">
                                            <div class="fw-semibold">{{ company.name }}</div>
                                            <small class="text-muted" (click)="copy(company.documentNumber); $event.stopPropagation();">{{ company.documentNumber | cpfCnpj }} <i class="ti ti-copy ti-ssm"></i></small>
                                            <small class="ms-2 text-muted"><i class="ti ti-calendar ti-ssm"></i>{{ company.createdAt | date :'dd/MM/yyyy HH:mm' }}</small>
                                        </td>
                                        <td>
                                            @if (company.city && company.state) {
                                                <small>{{ company.city }}/{{ company.state }}</small>
                                            } @else {
                                                <small class="text-muted">—</small>
                                            }
                                        </td>
                                        <td>
                                            <div class="d-flex flex-column gap-1">
                                                @if (company.email) {
                                                    <small>
                                                        <i class="ti ti-mail ti-sm"></i>
                                                        {{ company.email }}
                                                    </small>
                                                }
                                                @if (company.phones && company.phones.length > 0) {
                                                    <small>
                                                        <app-phone [areaCode]="company.phones[0].ddd" [phone]="company.phones[0].number" [isFax]="company.phones[0].isFax"/>
                                                    </small>
                                                }
                                                @if (!company.email && (!company.phones || company.phones.length === 0)) {
                                                    <small class="text-muted">—</small>
                                                }
                                            </div>
                                        </td>
                                        <td class="text-end ">
                                            {{ company.totalInstallmentRemaining || 0 }}
                                        </td>
                                        <td class="text-end pe-4">
                                            @if (company.estimatedDebtValue > 0) {
                                                <strong>{{ company.estimatedDebtValue | currency:'BRL' }}</strong>
                                            } @else {
                                                <span class="text-muted">—</span>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

